import { createContext } from 'react';
import { type User } from '@/authorization-sdk';

export interface CurrentUserContextType {
  user?: User;
  permissionStrings?: string[];
}

export const CurrentUserContext = createContext<CurrentUserContextType>({});
